import { cx } from '../../utils/cx';

import { Pagination } from './PaginationBase';

import type { IPaginationRootProps } from './PaginationBase';

interface IPaginationDotProps extends Omit<IPaginationRootProps, 'children'> {
  /** The size of the pagination dot. */
  size?: 'md' | 'lg';
  /** Whether the pagination uses brand colors. */
  isBrand?: boolean;
  /** Whether the pagination is displayed in a card. */
  framed?: boolean;
}

export const PaginationDot = ({ framed, className, size = 'md', isBrand, ...props }: IPaginationDotProps) => {
  const sizes = {
    md: {
      root: cx('gap-3', framed && 'p-2'),
      button: 'h-2 w-2 after:-inset-x-1.5 after:-inset-y-2',
    },
    lg: {
      root: cx('gap-4', framed && 'p-3'),
      button: 'h-2.5 w-2.5 after:-inset-x-2 after:-inset-y-3',
    },
  };

  return (
    <Pagination.Root
      {...props}
      className={cx(
        'flex h-max w-max',
        sizes[size].root,
        framed && 'bg-alpha-white/90 rounded-full backdrop-blur',
        className
      )}
    >
      <Pagination.Context>
        {({ pages }) =>
          pages.map((page, index) =>
            page.type === 'page' ? (
              <Pagination.Item
                {...page}
                asChild
                key={index}
                className={cx(
                  'bg-quaternary outline-focus-ring relative cursor-pointer rounded-full after:absolute focus-visible:outline-2 focus-visible:outline-offset-2',
                  sizes[size].button,
                  page.isCurrent && 'bg-fg-brand-primary_alt',
                  isBrand && 'bg-fg-brand-secondary',
                  isBrand && page.isCurrent && 'bg-fg-white'
                )}
              ></Pagination.Item>
            ) : (
              <Pagination.Ellipsis {...page} key={index} />
            )
          )
        }
      </Pagination.Context>
    </Pagination.Root>
  );
};
